import { DocLayout } from './DocLayout';

export default function DocMarkdown() {
  return (
    <DocLayout title="Formatare Markdown">
      <h2>Ce este Markdown?</h2>
      <p>
        Markdown este un limbaj simplu de formatare a textului. Îl poți folosi în câmpurile de descriere
        ale activităților și prietenilor pentru a adăuga titluri, text bold, italic, liste și altele.
      </p>

      <h2>Formatare text</h2>
      <table>
        <thead>
          <tr>
            <th>Ce scrii</th>
            <th>Ce obții</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><code>**text bold**</code></td>
            <td><strong>text bold</strong></td>
          </tr>
          <tr>
            <td><code>*text italic*</code></td>
            <td><em>text italic</em></td>
          </tr>
          <tr>
            <td><code>***bold și italic***</code></td>
            <td><strong><em>bold și italic</em></strong></td>
          </tr>
        </tbody>
      </table>

      <h2>Titluri</h2>
      <p>Folosește <code>#</code> la începutul liniei pentru a crea titluri. Cu cât sunt mai multe simboluri <code>#</code>, cu atât titlul este mai mic:</p>
      <table>
        <thead>
          <tr>
            <th>Ce scrii</th>
            <th>Rezultat</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td><code># Titlu mare</code></td>
            <td>Titlu de nivel 1 (mare)</td>
          </tr>
          <tr>
            <td><code>## Titlu mediu</code></td>
            <td>Titlu de nivel 2 (mediu)</td>
          </tr>
        </tbody>
      </table>

      <h2>Liste</h2>
      <h3>Liste cu puncte</h3>
      <p>Scrie <code>-</code> sau <code>*</code> la începutul fiecărei linii:</p>
      <pre><code>{`- Primul element
- Al doilea element
- Al treilea element`}</code></pre>

      <h3>Liste numerotate</h3>
      <p>Scrie numărul urmat de <code>.</code> la începutul liniei:</p>
      <pre><code>{`1. Primul pas
2. Al doilea pas
3. Al treilea pas`}</code></pre>

      <h2>Paragrafe și rânduri noi</h2>
      <p>
        Pentru un nou paragraf, lasă o linie goală între texte. Pentru un simplu rând nou (fără spațiu suplimentar), apasă Enter o singură dată.
      </p>

      <h2>Exemplu complet</h2>
      <pre><code>{`# Atelier de pictură

Vino să descoperi **arta picturii** într-un atelier interactiv!

## Program

- *10:00* — Deschidere și introducere
- *10:30* — Sesiune practică
- *12:00* — Prezentarea lucrărilor

## Ce trebuie să aduci

1. Bună dispoziție
2. Haine care se pot murdări
3. Un șorț (opțional)`}</code></pre>

      <h2>Sfaturi</h2>
      <ul>
        <li>Folosește butonul <strong>Previzualizare</strong> pentru a vedea cum va arăta textul înainte de salvare.</li>
        <li>Nu exagera cu formatarea — un text curat și simplu se citește mai ușor.</li>
        <li>Titlurile (<code>#</code>, <code>##</code>) sunt utile pentru a organiza descrieri lungi în secțiuni.</li>
      </ul>
    </DocLayout>
  );
}
